import { render, staticRenderFns } from "./ContinuousAgeIframe.vue?vue&type=template&id=5f8c052a&"
import script from "./ContinuousAgeIframe.vue?vue&type=script&lang=js&"
export * from "./ContinuousAgeIframe.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousAgeIframe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
